import React, { useState } from 'react';
import { useAppStore } from '@/lib/store';

export default function LoginView() {
  const { login } = useAppStore();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const ok = login(email.trim(), password);
    if (!ok) setError('Invalid email or password.');
    else setError('');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#181920] px-4">
      {/* Logo */}
      <div className="mb-8 text-center">
        <h1 className="text-white font-bold text-[32px] tracking-tight">
          <span className="text-[#F6661E]">P</span>alinos
        </h1>
        <p className="text-[#8f9196] text-[14px] mt-1">Your personal AI workspace</p>
      </div>

      {/* Card */}
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-[380px] bg-[#232426] border border-[#515153] rounded-xl p-8 shadow-2xl"
      >
        <h2 className="text-white font-bold text-[18px] mb-6">Sign in</h2>

        {error && (
          <div className="mb-4 px-3 py-2 bg-[#2d1414] border border-[#7a3535] rounded-md text-[#e17171] text-[13px]">
            {error}
          </div>
        )}

        <div className="space-y-4">
          <div>
            <label className="block text-[#8f9196] text-[12px] font-medium mb-1.5">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="gnanies@amazon.com"
              className="w-full bg-[#2b2c2f] border border-[#515153] rounded-md px-3 py-2.5 text-white text-[14px] placeholder-[#515153] focus:outline-none focus:border-[#6498CC] transition-colors"
              autoComplete="email"
            />
          </div>

          <div>
            <label className="block text-[#8f9196] text-[12px] font-medium mb-1.5">Password</label>
            <div className="relative">
              <input
                type={showPass ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••••"
                className="w-full bg-[#2b2c2f] border border-[#515153] rounded-md px-3 py-2.5 text-white text-[14px] placeholder-[#515153] focus:outline-none focus:border-[#6498CC] transition-colors pr-10"
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShowPass((v) => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8f9196] hover:text-white transition-colors"
              >
                {showPass ? (
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>
                ) : (
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                )}
              </button>
            </div>
          </div>
        </div>

        <button
          type="submit"
          className="mt-6 w-full py-2.5 bg-[#6498CC] hover:bg-[#5282b8] text-white font-semibold text-[14px] rounded-md transition-colors shadow-lg"
        >
          Sign in
        </button>
      </form>

      <p className="mt-6 text-[#515153] text-[12px]">Palinos — private workspace. Not for public use.</p>
    </div>
  );
}
